import useSWR from 'swr'
import { GetSessionID } from '../Utility/SessionUtility';

/**
 * 作品画像データの型
 */
export interface WorkImageType {
    file_data: string,
}

/**
 * 作品画像Hook
 * 指定した作品IDの作品画像を取得する
 * @param id 作品ID
 */
export function useWorkImage(id?:string) {

    const fetchAddress = `/competition/api/management/registrationArtworkData?artworkId=${id}&sessionId=${GetSessionID()}`;

    const fetcher = () => fetch(fetchAddress).then(res => res.json());

    const {data, error, isLoading, mutate} = useSWR(`WorkImage-${id}`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * 作品画像データ
         */
        workImage: data?.file_data,
        
        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}